var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllusSexoFem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#efebf6;}.cls-3{fill:#9383bb;}.cls-4{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_101",
    "data-name": "Elipse 101",
    className: "cls-1",
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1236",
    "data-name": "Grupo 1236"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_101-2",
    "data-name": "Elipse 101",
    className: "cls-2",
    cx: 32.5,
    cy: 32.5,
    r: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37,16.2A11.45,11.45,0,0,0,32.12,15a11.82,11.82,0,0,0-4.85,1.17"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.25,50c-3.48-2-8.76-2-11.21-5a6.74,6.74,0,0,1-1.26-4l.06-2.17a11.6,11.6,0,0,0,2.73-6.38s.78,0,.78-1a22.09,22.09,0,0,1,1-3.13c.26-.78.26-1.82-1-1.56l.08-.26h0v-.11c.08-.32.2-.81.31-1.41h-.13c.09-.75.21-1.69.33-2.64a6.41,6.41,0,0,0-3.13-6.51,10.93,10.93,0,0,0-1.59-.84,16.18,16.18,0,0,0-5.13-1.23A16.24,16.24,0,0,0,27,14.9a11.47,11.47,0,0,0-1.59.84,6.42,6.42,0,0,0-3.12,6.51c.12.95.23,1.89.33,2.64h-.14c.11.6.23,1.09.31,1.41l0,.11h0c0,.17.07.26.07.26-1.3-.26-1.3.78-1,1.56a21.92,21.92,0,0,1,1,3.13c0,1,.78,1,.78,1a11.65,11.65,0,0,0,2.74,6.38L26.46,41a6.67,6.67,0,0,1-1.26,4c-2.45,2.93-7.73,3-11.2,5-2.91,1.64-3.25,6.79-3.36,9.62C16.56,64.67,23.36,65,31.78,65h.69c8.41,0,15.21-.28,21.13-5.36C53.49,56.76,53.16,51.61,50.25,50Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 32.12,
    cy: 22.82,
    rx: 10.45,
    ry: 9.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.23,13.21a9.17,9.17,0,0,1,7.59,6.72c1.64,6.21,2,17,.8,24.3-1.11,0-1.34-.23-1.34-.23a21.3,21.3,0,0,0,.17-3.51c0-.43-.37-.43-.37.21,0,.45-.2,3.24-.2,3.24a8.65,8.65,0,0,1-2.78-1l-.1-.59-.37.59-1.37,0-11.14-.1a10.36,10.36,0,0,0-3.44.85,4.73,4.73,0,0,0-.36-1.78,9.66,9.66,0,0,0-.42,1.8,9.84,9.84,0,0,0-2.07.84.27.27,0,0,1-.41-.23C20.37,42.07,20.09,34,20.09,34l-.36,11.13-.79.43s-.68-20.22,2.82-26.7C23.22,16.09,27.31,10.81,36.23,13.21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusSexoFem);
export default __webpack_public_path__ + "static/media/illus_sexo_fem.1aeb27b2b2ba612e1525b9c655c8a01e.svg";
export { ForwardRef as ReactComponent };